import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import map from 'lodash/map';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { AvatarApi } from 'services/avatar';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { BloxButton } from 'styled_components/Common/BloxButton';
import ImageCrop from 'sub_components/Common/ImageCrop';

const EditAvatarStyle = styled.div`
	width: 496px;
	position: relative;
	background: ${props => props.theme.modalBackground};
	color: ${props => props.theme.defaultFontColor};

	.edit-avatar-main {
		width: 100%;
		height: 306px;
		.ScrollbarsCustom-Track {
			right: 36px !important;
			top: 12px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.account} !important;
			width: 6px !important;
		}
		.ScrollbarsCustom-TrackY:before {
			border-left: none;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 6px !important;
		}

		.selection-wrapper {
			display: flex;
			flex-wrap: wrap;
			margin-left: 67px;
			align-items: center;
			width: 80%;
			#action-button {
				&.small {
					width: 96px;
					height: 96px;
				}
			}
			.avatar-selector {
				margin: 12px;
				img {
					width: 96px;
					height: 96px;

					//filter: grayscale(100%);
				}
			}
		}
		.edit-avatar-footer {
			width: 100%;
			height: 110px;
			position: relative;
			background-color: ${props => props.theme.white};
			.divider {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 3px;
				background-color: ${props => props.theme.Cool_Gray_Light_3};
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.boxShadow} inset;
			}
			.edit-avatar-buttons {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 544px;
		height: 100%;
		position: relative;
		background: ${props => props.theme.modalBackground};
		color: ${props => props.theme.defaultFontColor};

		.edit-avatar-main {
			width: 100%;
			height: 280px;
			.ScrollbarsCustom-Track {
				right: 48px !important;
				top: 12px !important;
			}
			.ScrollbarsCustom-ThumbY {
				background-color: ${props => props.theme.account} !important;
				width: 8px !important;
			}

			.ScrollbarsCustom-TrackY {
				background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
				width: 8px !important;
			}

			.selection-wrapper {
				margin-left: 67px;
			}
			.edit-avatar-footer {
				width: 100%;
				height: 108px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 100%;

		.edit-avatar-main {
			height: 480px;
			.ScrollbarsCustom-Track {
				right: 48px !important;
				top: 30px !important;
			}
			.ScrollbarsCustom-ThumbY {
				background-color: ${props => props.theme.account} !important;
				width: 10px !important;
			}
			.ScrollbarsCustom-TrackY {
				max-height: 425px;
			}

			.ScrollbarsCustom-TrackY {
				background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
				box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
					1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
				width: 10px !important;
			}

			.selection-wrapper {
				width: 912px;
				margin-left: 50px;
				#action-button {
					&.small {
						width: 200px;
						height: 200px;
					}
				}
				.avatar-selector {
					margin: 30px;
					img {
						width: 200px;
						height: 200px;
					}
				}
			}
			.edit-avatar-footer {
				width: 100%;
				height: 128px;
				.divider {
					height: 4px;
				}
			}
		}
	}
`;

export const EditAvatar = ({
	closeModal,
	currentAvatar,
	updateUserAvatar,
	auth_status,
	callback,
	setModalContent,
}) => {
	const [selectedAvatar, setSelectedAvatar] = useState();

	function updateSelected(id) {
		updateUserAvatar(id);
		callback(selectedAvatar);
		setTimeout(() => {
			const currentAvatar = new AvatarApi().getUserAvatar(auth_status);
			setSelectedAvatar(currentAvatar);
			callback(currentAvatar);
		}, 1000);
	}
	useEffect(() => {
		setSelectedAvatar(currentAvatar);
		callback(currentAvatar);
	}, [setSelectedAvatar]);

	function renderAvatars() {
		const avatars = new AvatarApi().getAll();

		return map(avatars, (avatar, index) => {
			return (
				<ActionButton
					key={avatar}
					className='avatar-selector small'
					style={{ backgroundImage: avatar }}
					onClick={() => updateSelected(index)}
					data-cy={`avatar-${index}`}
				>
					<img src={avatar} alt='avatar' data-cy={`avatar-image-${index}`} />
				</ActionButton>
			);
		});
	}

	function setNewAvatar(userImage) {
		updateUserAvatar(null, userImage);
		setSelectedAvatar(userImage);
		callback(userImage);
	}
	function handleAvatarDelete() {
		updateUserAvatar(null);
		setTimeout(() => {
			const currentAvatar = new AvatarApi().getUserAvatar(auth_status);
			setSelectedAvatar(currentAvatar);
			callback(currentAvatar);
		}, 1000);
	}

	return (
		<EditAvatarStyle className='edit-avatar-wrapper'>
			<div className='edit-avatar-main'>
				<ScrollView>
					<div className='selection-wrapper'>
						<ActionButton
							className='avatar-selector small'
							//onClick={onClick(index)}
							//data-cy={`avatar-${index}`}
						>
							<ImageCrop
								callback={setNewAvatar}
								auth_status={auth_status}
								handleAvatarDelete={handleAvatarDelete}
								setModalContent={setModalContent}
							/>
						</ActionButton>
						{renderAvatars()}
					</div>
				</ScrollView>
				<div className='edit-avatar-footer'>
					<div className='divider' />
					<div className='edit-avatar-buttons'>
						<BloxButton
							id='button-1'
							text='DONE'
							module='storage'
							enabled={true}
							className='buttons41'
							onClick={closeModal}
						/>
					</div>
				</div>
			</div>
		</EditAvatarStyle>
	);
};
